import React, { ReactNode } from "react";
import Avatar from "@mui/material/Avatar";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import { BiCheck } from "react-icons/bi";
import { ListItem, ListItemText, ListItemIcon } from "./listStyle";

import { IButtonActions } from "../../dataProvider/interfaces/IEvent";
import Box from "@mui/material/Box";

interface Props {
  listKey: number;
  id: any;
  addClass?: string;
  avatar?: ReactNode;
  label?: ReactNode;
  description?: ReactNode;
  isSelected?: boolean;
  isChecked?: boolean;
  removeActions?: string;
  buttonActions?: Array<IButtonActions>;
  onSelectItem?: (id: any) => void;
  onCheckedItem?: (id: any) => void;
}

const FdListItem = ({ ...props }: Props) => {
  const {
    listKey,
    id,
    addClass,
    avatar,
    label,
    description,
    isSelected,
    isChecked,
    buttonActions,
    removeActions,
    onSelectItem,
    onCheckedItem,
  } = props;

  //   if item is checked and it has avatar, this function will be called
  const avatarSelect = () => {
    return (
      <Avatar sx={{ background: (theme) => theme.palette.primary.main }}>
        <BiCheck />
      </Avatar>
    );
  };
  const getClassName = () => {
    let className = "";
    if (!avatar) {
      className = "listWithoutAvatar";
    }
    return `${className} ${addClass}`;
  };

  return (
    <ListItem
      key={listKey}
      onClick={() => onSelectItem && onSelectItem(id)} // item will be selected
      selected={isSelected}
      className={getClassName()}
    >
      {/* checkbox */}
      {onCheckedItem && (
        <ListItemIcon className={!avatar ? "iconWithoutAvatar" : undefined}>
          <Checkbox
            edge="start"
            onClick={(e) => e.stopPropagation()}
            onChange={() => {
              if (onCheckedItem) onCheckedItem(id);
            }}
            disableRipple
          />
        </ListItemIcon>
      )}
      {/* avatar or image */}
      {avatar && (
        <ListItemAvatar className={isSelected ? "abc" : ""}>
          {isChecked ? avatarSelect() : avatar}
        </ListItemAvatar>
      )}
      {/* text of the item */}
      <ListItemText primary={label} secondary={description} />
      <ListItemSecondaryAction sx={{ "& .MuiButtonBase-root": { ml: 1 },display:"flex",alignItems:"center" }}>
        {/* all button action on right side will be perform here */}
        {buttonActions &&
          buttonActions.map((el, index) => {
            if(el.type === 'label'){
              return el.label
            }
            if (el.type && removeActions?.includes(el.type)) return null; //  if there is any permission to access buttons
            return (
           <Box sx={{display:"flex",alignItems:"center"}}>
               <IconButton
                key={index}
                edge="end"
                onClick={() => el?.callback && el.callback(id)}
                sx={{ height: "32px", width: "32px" }}
              >
                {el.icon}
              </IconButton>
           </Box>
            );
          })}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default FdListItem;
